import { useEffect, useRef } from "react";
import { Navigate } from "react-router-dom";
import { useEntryPointActions } from "../../store/entryPointStore";
import { useEntryPoint } from "../../data/queries/entryPointQueries";
import { IconLoading } from "../../components/Loading/IconLoading";
import { EntryPointContext } from "./entryPointContext";
import { IsSubscriptionValid } from "../../utils/helpers";

export const EntryPointProvider = ({ children }) => {
  const { setFirstTimeUser, setFirstTimeOrganization } = useEntryPointActions();
  const isEntryPointChecked = useRef(false);
  const validSub = IsSubscriptionValid();

  const {
    data: entryPointData,
    isPending,
    isSuccess,
  } = useEntryPoint({
    enabled: !isEntryPointChecked.current,
  });

  useEffect(() => {
    if (!isEntryPointChecked.current && !isPending && isSuccess) {
      isEntryPointChecked.current = true;
    }

    if (entryPointData) {
      setFirstTimeUser(entryPointData.FirstTimeUser);
      setFirstTimeOrganization(entryPointData.FirstTimeOrganization);
    }
  }, [
    entryPointData,
    isPending,
    isSuccess,
    setFirstTimeUser,
    setFirstTimeOrganization,
  ]);

  if (isPending && !isSuccess) {
    return <IconLoading />;
  }

  if (!validSub) {
    return <Navigate to="/duedates/invalidlicense" />;
  }

  if (entryPointData?.FirstTimeOrganization || entryPointData?.FirstTimeUser) {
    return <Navigate to="/duedates/welcome" />;
  }

  return (
    <EntryPointContext.Provider
      value={{
        firstTimeOrganization: entryPointData?.FirstTimeOrganization,
        firstTimeUser: entryPointData?.FirstTimeUser,
      }}
    >
      {children}
    </EntryPointContext.Provider>
  );
};
